import type { SxProps, Theme } from '@mui/material';

export type SystemProductType = 'AVCS' | 'ADP' | 'ENP';

/** Maps UI display values to API filter values for POST /v2/products/search */
export const PRODUCT_TYPE_API_VALUE: Record<SystemProductType, string> = {
  AVCS: 'avcs',
  ADP: 'adp',
  ENP: 'aenp',
};

export const PRODUCT_TYPE_COLOR: Record<SystemProductType, string> = {
  AVCS: '#DF017C',
  ADP: '#84B0B5',
  ENP: '#7476B7',
};

export const PRODUCT_TYPE_LABEL: Record<SystemProductType, string> = {
  AVCS: 'AVCS',
  ADP: 'ADP',
  ENP: 'ENP',
};

export function isSystemProductType(value: string | null | undefined): value is SystemProductType {
  return value === 'AVCS' || value === 'ADP' || value === 'ENP';
}

/** MUI sx overrides for type-filter chips */
export function productTypeChipSx(
  type: SystemProductType,
  active: boolean,
): SxProps<Theme> {
  const color = PRODUCT_TYPE_COLOR[type];
  return active
    ? { bgcolor: color, color: '#fff', '&:hover': { bgcolor: color, filter: 'brightness(0.9)' } }
    : { borderColor: color, color, '&:hover': { bgcolor: `${color}20` } };
}

/** Injects product type colors as CSS custom properties on :root at app startup */
export function injectProductTypeCssVars(): void {
  const root = document.documentElement;
  for (const [type, color] of Object.entries(PRODUCT_TYPE_COLOR)) {
    root.style.setProperty(`--product-type-${type.toLowerCase()}`, color);
  }
}
